import React from 'react';
import PropTypes from 'prop-types';
import {withApollo} from 'react-apollo';
import {URL_LABEL_LIST} from "./gql/query";
import {Select, Spin, message} from 'antd';
import {injectIntl} from 'react-intl';

const { Option } = Select;


class LabelFilter extends React.Component {
  static propTypes = {
    labelType: PropTypes.string.isRequired,
    labelName: PropTypes.string.isRequired,
    labelValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false
    }
  }

  handleSearch = (search) => {
    this.loadOptions(search);
  }

  loadOptions(search) {
    this.setState({loading: true});
    const { client, labelType, labelName } = this.props;
    client
      .query({
        query: URL_LABEL_LIST,
        variables: { labelType, labelName,  search }
      })
      .then(({data}) => {
        this.setState({data: data.data, loading: false});
      }).catch(this.handleInternalError);
  }

  handleInternalError = (err) => {
    const { formatMessage } = this.props.intl;
    message.error(formatMessage({id: 'general.network-error',
      defaultMessage: 'Network error, try again later'}));
  }

  componentDidMount() {
    this.loadOptions()
  }

  render() {
    const { loading, data } = this.state;
    let _data = [];

    for (let i in data) {
        _data.push(JSON.parse(data[i].replace(/\'/g, '"')));
    }
    
    const options = _data.map(d => {
      if (typeof d === 'object' && 'id' in d) {//todo: hotfix only for umt_source ({id: int, value: str}) dictionary
          return <Option key={d.id}> {d.value} </Option>
      } else {
        return <Option key={d}>{d}</Option>
      }
    });
    return (<Select
        value={this.props.labelValue}
        showSearch={true}
        allowClear={true}
        placeholder={this.props.placeholder}
        notFoundContent={loading ? <Spin size="small" /> : null}
        defaultActiveFirstOption={false}
        showArrow={true}
        onFocus={this.handleSearch}
        onSearch={this.handleSearch}
        onChange={this.props.onChange}
        filterOption={false}
      >
      {options}
      </Select>)
  }
}


export default withApollo(injectIntl(LabelFilter));


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/label-filter.js